import React from 'react';
import Tooltip from '../Tooltip';

const ListTooltip = ({ children, list }: { children: React.ReactNode; list: string[] }) => {
  return (
    <Tooltip
      title={
        <div
          style={{
            margin: '-5px -8px',
            ...(list.length > 10 && {
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
            }),
          }}>
          {list.map((item, index) => {
            const isLastRow =
              list.length > 10
                ? Math.floor(index / 2) === Math.floor((list.length - 1) / 2)
                : index === list.length - 1;

            return (
              <div
                style={{
                  borderBottom: isLastRow ? 'none' : '1px solid #cbd5e0',
                  padding: list.length > 10 
                    ? `5px ${index % 2 === 0 ? '16px' : '8px'} 5px ${index % 2 === 0 ? '8px' : '16px'}`
                    : '5px 8px',
                }}
                key={index}>
                {item}
              </div>
            );
          })}
        </div>
      }
      isIcon={true}>
      {children}
    </Tooltip>
  );
};

export default ListTooltip;
